import { FontFamily } from './fontFamily';
import { FontWeight } from './fontWeight';

export const TypographyVariant = {
  HeadlineLarge: 'headlineLarge',
  HeadlineMedium: 'headlineMedium',
  HeadlineSmall: 'headlineSmall',
  TitleLarge: 'titleLarge',
  TitleMedium: 'titleMedium',
  TitleSmall: 'titleSmall',
  BodyLarge: 'bodyLarge',
  BodyMedium: 'bodyMedium',
  BodySmall: 'bodySmall',
  LabelLarge: 'labelLarge',
  LabelMediumLarge: 'labelMediumLarge',
  LabelMedium: 'labelMedium',
  LabelSmall: 'labelSmall',
};

export const typographyScale = {
  [TypographyVariant.HeadlineLarge]: {
    fontFamily: FontFamily.extraBold,
    fontSize: 28,
    lineHeight: 36 / 28,
    letterSpacing: 0,
    fontWeight: FontWeight.bold,
  },
  [TypographyVariant.HeadlineMedium]: {
    fontFamily: FontFamily.extraBold,
    fontSize: 24,
    lineHeight: 32 / 24,
    letterSpacing: 0,
    fontWeight: FontWeight.bold,
  },
  [TypographyVariant.HeadlineSmall]: {
    fontFamily: FontFamily.extraBold,
    fontSize: 22,
    lineHeight: 28 / 22,
    letterSpacing: 0,
    fontWeight: FontWeight.bold,
  },

  [TypographyVariant.TitleLarge]: {
    fontFamily: FontFamily.bold,
    fontSize: 20,
    lineHeight: 26 / 20,
    letterSpacing: 0,
    fontWeight: FontWeight.bold,
  },
  [TypographyVariant.LabelMediumLarge]: {
    fontFamily: FontFamily.bold,
    fontSize: 18,
    lineHeight: 24 / 18,
    letterSpacing: 0,
    fontWeight: FontWeight.bold,
  },
  [TypographyVariant.TitleMedium]: {
    fontFamily: FontFamily.bold,
    fontSize: 16,
    lineHeight: 22 / 16,
    letterSpacing: 0.15,
    fontWeight: FontWeight.bold,
  },
  [TypographyVariant.TitleSmall]: {
    fontFamily: FontFamily.bold,
    fontSize: 14,
    lineHeight: 20 / 14,
    letterSpacing: 0.1,
    fontWeight: FontWeight.bold,
  },

  [TypographyVariant.BodyLarge]: {
    fontFamily: FontFamily.regular,
    fontSize: 18,
    lineHeight: 24 / 18,
    letterSpacing: 0.15,
    fontWeight: FontWeight.regular,
  },
  [TypographyVariant.BodyMedium]: {
    fontFamily: FontFamily.regular,
    fontSize: 16,
    lineHeight: 20 / 16,
    letterSpacing: 0.2,
    fontWeight: FontWeight.regular,
  },
  [TypographyVariant.BodySmall]: {
    fontFamily: FontFamily.regular,
    fontSize: 12,
    lineHeight: 18 / 12,
    letterSpacing: 0.2,
    fontWeight: FontWeight.regular,
  },

  [TypographyVariant.LabelLarge]: {
    fontFamily: FontFamily.bold,
    fontSize: 14,
    lineHeight: 18 / 14,
    letterSpacing: 0.4,
    fontWeight: FontWeight.bold,
  },
  [TypographyVariant.LabelMedium]: {
    fontFamily: FontFamily.bold,
    fontSize: 12,
    lineHeight: 16 / 12,
    letterSpacing: 0.5,
    fontWeight: FontWeight.bold,
  },
  [TypographyVariant.LabelSmall]: {
    fontFamily: FontFamily.bold,
    fontSize: 11,
    lineHeight: 14 / 11,
    letterSpacing: 0.5,
    fontWeight: FontWeight.bold,
  },
};

